import { render, staticRenderFns } from "./HonjoCard.vue?vue&type=template&id=3f2b83c5"
import script from "./HonjoCard.vue?vue&type=script&lang=ts"
export * from "./HonjoCard.vue?vue&type=script&lang=ts"
import style0 from "./HonjoCard.vue?vue&type=style&index=0&id=3f2b83c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports